export default __webpack_public_path__ + "static/media/gummies@3x.0c678ee4.png";